import investment from "./investment"
import allocation from "./data/allocation"

export default investment({ allocationData: allocation })